module.exports = __webpack_public_path__ + "img/tickets-chip.72e048fd.svg";